import React, { useState } from 'react';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { APNavBar } from './APNavBar';

const AccountDeletionRequest = () => {
  const [email, setEmail] = useState('');
  const [reason, setReason] = useState('');
  return (
    <div>
    <APNavBar/>

    <Container>
      <Row className="justify-content-center mt-5">
        <Col xs={12} md={6}>
          <h2 className="text-center mb-4">Request Account Deletion</h2>
          <Form  action="https://formsubmit.co/sanedroid@gmail.com" method="POST">
            <Form.Group controlId="formEmail">
              <Form.Label>Email:</Form.Label>
              <Form.Control
                type="email"
                name='email'
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
               <Form.Label>Reason</Form.Label>
              <Form.Control
                type="text"
                name='message'
                placeholder="Enter your reason"
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                required
              />
            </Form.Group>
            <Button variant="primary" type="submit" block>
              Submit Request
            </Button>
          </Form>
        </Col>
      </Row>
    </Container>
    </div>
  );
};

export default AccountDeletionRequest;
